export const regions = ['EU', 'US', 'KR', 'TW'] as const

type Region = typeof regions[number]
export default Region
